import React from 'react';
import { FieldName, FullWidthCell } from "../../Components/DashboardTable";
import { BookingType } from '../../Components/Types';
import { ConvertToPounds, getDaysArray } from '../../Components/Functions';
import moment from 'moment';
import Button  from '../../Components/Button';
import styled from 'styled-components';
import { useMsal } from '@azure/msal-react';
import { BookingAPI } from 'API/BookingAPI';
import { toastConfig } from 'Components/Constants';
import { toast } from 'react-toastify';

type MyBookingsProps = {
    bookings: BookingType[][];
    visiblePage: number;
    licenseCheck: (bookingId: number) => any;
    bookingPayments: (bookingId: number, vehicleName: string) => void;
}
const TableDivider = styled.div`
    height: 2px;
    width: 200%;
    background-color: var(--main-orange-color);
    margin: 5px;
`;

function MobileBookingTable({ bookings, visiblePage, licenseCheck, bookingPayments }: MyBookingsProps) {
    
    const { instance } = useMsal();
    
    const cancelBooking = async (bookingId: number) => {
        const response = await BookingAPI.cancel(instance, bookingId);
        const message = response.message;
        toast.success(message, { ...toastConfig, toastId: message + "-toast" });
    }

    return (
        <>
        {bookings.length > 0 ?
            bookings[visiblePage].map((booking: BookingType) => {
            var startDate = moment();
            var endDate = moment();
            var duration: number = 0;
            var errMessage: string = '';
            try {
                startDate = moment(booking.start_date.split('T')[0]);
                endDate = moment(booking.end_date.split('T')[0]);
                duration = getDaysArray(startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')).length;
            }
            catch (err)
            {
                errMessage = `${err} - ${booking.start_date} to ${booking.end_date}`;
            }
            return (
                <React.Fragment key={booking.booking_id}>
                    <tbody>
                        <tr>
                            <FieldName>Reference</FieldName>
                            <td>{booking.booking_id}</td>
                        </tr>
                        <tr>
                            <FieldName>Vehicle</FieldName>
                            <td>{booking.vehicle_name}</td>
                        </tr>
                        <tr>
                            <FieldName>Regmark</FieldName>
                            <td>{booking.regmark}</td>
                        </tr>
                        <tr>
                            <FieldName>Duration (days)</FieldName>
                            <td>{duration}</td>
                        </tr>
                        <tr>
                            <FieldName>Cost</FieldName>
                            <td>{ConvertToPounds(booking.total_cost)}</td>
                        </tr>
                        <tr>
                            <FieldName>Collection Date</FieldName>
                            <td>{startDate.format('YYYY-MM-DD')}</td>
                        </tr>
                        <tr>
                            <FieldName>Return Date</FieldName>
                            <td>{endDate.format('YYYY-MM-DD')}</td>
                        </tr>
                        <tr>
                            <FieldName>Driving Licence Check</FieldName>
                            <td>{booking.mandate_status_description == "N/A" ?
                                booking.mandate_status_description :
                                <Button
                                    type="button"
                                    text={booking.mandate_status_description}
                                    colour="dark"
                                    onClick={() => booking.mandate_status < 3 && licenseCheck(booking.booking_id)}
                                    disabled={booking.mandate_status > 2}
                                />
                            }</td>
                        </tr>
                        <tr>
                            <td>
                                <Button
                                    type="button"
                                    text="payments"
                                    colour="dark"
                                    css={{marginTop: "2em"}}
                                    onClick={() => bookingPayments(booking.booking_id, booking.vehicle_name)}
                                />
                                {startDate.isAfter() &&
                                    <Button
                                        type="button"
                                        text="cancel"
                                        colour="dark"
                                        onClick={() => cancelBooking(booking.booking_id)}
                                    /> 
                                }
                                {errMessage}                
                                <TableDivider />
                            </td>
                        </tr>
                    </tbody>
                </React.Fragment>
            );
        }) :
        <tr>
            <FullWidthCell colSpan={100}>No bookings found.</FullWidthCell>
        </tr>}
        </>
    );
}
export default MobileBookingTable;
